export default __webpack_public_path__ + "static/media/terms.3552035d.pdf";